export default __webpack_public_path__ + "static/media/Cryptocurrency.bf3ef9e2.jpeg";